var map = {
	"./avatar-abbey-base-full.png": 26214,
	"./avatar-abbey-dino-full.png": 18011,
	"./avatar-abbey-fall-full.png": 38473,
	"./avatar-abbey-smoothie-full.png": 2914,
	"./avatar-abbey-space-full.png": 40342,
	"./avatar-abbey-spring-full.png": 14197,
	"./avatar-abbey-summer-full.png": 43490,
	"./avatar-abbey-winter-full.png": 75079
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5238;